import { useContext } from 'react'
import { Channel, SpaceContext, useSpaceDataStore } from 'use-towns-client'
import { useShallow } from 'zustand/react/shallow'

/**
 * includes all channels for a space
 * for joined only channels, see useMyChannels in lib
 */
export const useSpaceChannels = (): Channel[] => {
    const spaceId = useContext(SpaceContext)?.spaceId
    return useSpaceDataStore(
        useShallow((state) => {
            return (
                (spaceId &&
                    state.spaceDataMap?.[spaceId]?.channelGroups
                        .flatMap((cg) => cg.channels)
                        .filter((c) => !c.disabled)) ||
                []
            )
        }),
    )
}
